export { default } from './toDashedString'
export * from './toDashedString'
